import { render, staticRenderFns } from "./SideBarMenu.vue?vue&type=template&id=65803813&scoped=true&"
import script from "./SideBarMenu.vue?vue&type=script&lang=js&"
export * from "./SideBarMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideBarMenu.vue?vue&type=style&index=0&id=65803813&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65803813",
  null
  
)

export default component.exports